import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductImportFromExistCandidate } from 'src/typings';

export interface ExistImportSelectionDialogData {
  article: string;
  candidates: ProductImportFromExistCandidate[];
}

@Component({
  selector: 'app-exist-import-selection-dialog',
  templateUrl: './exist-import-selection-dialog.component.html',
  styleUrls: ['./exist-import-selection-dialog.component.scss']
})
export class ExistImportSelectionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ExistImportSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExistImportSelectionDialogData
  ) {}

  choose(candidate: ProductImportFromExistCandidate) {
    this.dialogRef.close(candidate);
  }

  trackByExistId(_: number, candidate: ProductImportFromExistCandidate) {
    return candidate.exist_product_id;
  }
}
